<template>
  <div class="Charts0Border">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Charts0Border',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {};
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {},
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.Charts0Border {
  // position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
}
</style>